export default "__VITE_ASSET__WhAubT2b__"